export var TERM_HIERARCHY_DISPLAY_SEPARATOR = ' - ';
export var TRUNCATE_VALUE = '...';